import { useEffect } from "react";

/** The class Chakra gives every NativeSelect root (the select's wrapper). */
export const NATIVE_SELECT_ROOT_CLASS = "chakra-native-select__root";

/**
 * A native select is drawn 28px tall like every other control; below 1024
 * its root draws a centred 32px press area with `::after` (the nativeSelect
 * recipe, P-20). A `<select>` cannot draw a pseudo-element, so a press on
 * the part of that area outside the select lands on the root. This forwards
 * it: the select takes focus and opens its list, as a press on the select
 * itself would. Presses on the select itself are left to the browser.
 *
 * Installed once for the app (`AppProviders`).
 *
 * docs/design-system/DEVIATIONS.md, Prompts (7h) row 39.
 */
export function useNativeSelectPressArea() {
  useEffect(() => {
    const onPointerDown = (event: PointerEvent) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (!target.classList.contains(NATIVE_SELECT_ROOT_CLASS)) return;
      const select = target.querySelector("select");
      if (!select || select.disabled) return;
      event.preventDefault();
      select.focus();
      try {
        select.showPicker();
      } catch {
        // showPicker needs a user gesture and a supporting browser; focus
        // alone still leaves the select one key press from open.
      }
    };
    document.addEventListener("pointerdown", onPointerDown);
    return () => document.removeEventListener("pointerdown", onPointerDown);
  }, []);
}
